import { SPATEM } from '_lib/api';

export enum SpatemActivityStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface SpatemRequestPayload {
  roadSegmentIds: string[];
}

export interface UpdateSpatemRsusPayload {
  /** The SPATEM's id in the store. */
  id: string;
  identifier: string;
  /** RSU names. */
  rsus: string[];
}

export interface SpatemReducerState {
  loading: boolean;
}

export type { SPATEM };

